import { atom, selector } from "recoil";
import { getMemberAdAPI } from "../../../../api";

// Dashboard 데이터 상태
export const dashboardDataState = atom({
  key: "dashboardDataState",
  default: {
    ads: [],
    pagination: null,
    loading: false,
    error: null,
    lastFetched: null,
  },
});

// Dashboard 진입 상태
export const dashboardEnteredState = atom({
  key: "dashboardEnteredState",
  default: false,
});

// Dashboard 진입 시 데이터 로딩 상태
export const dashboardLoadingState = atom({
  key: "dashboardLoadingState",
  default: false,
});

// 선택된 광고 상태
export const selectedAdState = atom({
  key: "selectedAdState",
  default: null,
});
